import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './fastfood.json';

const FastFood = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Food industry, nutrition, and consumer culture vocabulary. B2 level English exercises with grammar, reading, and discussion."
            level="B2"
            title="Fast Food"
            image="/Images/fast-food1.webp"
            seoTitle="Free English Lesson Plans: Fast Food"
            seoDescription="Food industry, nutrition, and consumer culture vocabulary. B2 level English exercises with grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default FastFood;


